import { Link, useNavigate } from "react-router-dom";
import { BlueOutline, BluePlain, RoundBluePlain, RoundGreyOutline, RoundGreyPlain, WhiteOutline, WhitePlain } from "../ui/Buttons/generic/GenericButton";
import { useState, useRef, useEffect } from "react";
import "../../styles/header.css";
import { useLocation } from 'react-router-dom'; 

import { Logo, LogoTransparent } from "../../assets";
import arrowRight from "../../assets/arrow_right_alt-blue.svg";
import copyContent from "../../assets/content_copy.svg";
import copyContentHover from "../../assets/content_copy_hover.svg";
import fold from "../../assets/devices_fold.svg";
import foldHover from "../../assets/devices_fold_hover.svg";
import group from "../../assets/group.svg";
import groupHover from "../../assets/group_hover.svg";
import hamburger from "../../assets/hamburger-menu.svg";
import hamburgerW from "../../assets/hamburger-menu-w.svg";
import menuLogo from "../../menu_logo.svg";
import right from "../../arrow_right.svg";
import closeIcon from "../../close_small.svg";
import RedArrow from '../../assets/red_arrow.svg';
import UserIcon from '../../assets/user_icon.svg';
import UserIconHover from '../../assets/user_icon_hover.svg';
import MessageIcon from '../../assets/message_icon.svg';
import MessageIconHover from '../../assets/message_icon_hover.svg';
import LogoutIcon from '../../assets/logout_icon.svg';
import LogoutIconHover from '../../assets/logout_icon_hover.svg';
import UserFallback from '../../assets/svg/user_fallback.svg';
import Portal from '../../assets/svg/portal.svg';
import PortalHover from '../../assets/svg/portal-color.svg';

import { _getTypeFreelance } from "services/parcours/create-entreprise.service";
import { get, post } from "services/config";
import Cookies from "js-cookie";


const ActionButtons= ({type, isLoggedIn= false, logout, showMenu, username, picture}: {type: string, isLoggedIn?: boolean, logout: ()=> void, showMenu: ()=> void, username: string, picture: string}) => {
    let textCname= "text-[16px] leading-[100%] font-semibold";
    textCname+= type==="non-default" ? " text-white" : " text-primary-blue";

    return (<>
        <div className='flex gap-[.5rem]'>
            {
                isLoggedIn ? //<- remove later
                    <>
                    {
                        <div className="flex flex-row gap-[10px] justify-end items-center h-[30.38px] w-[201px] cursor-pointer" title="Profil" onMouseEnter={showMenu}>
                            <img src={RedArrow} alt="ARR_DOWN" />
                            <div className={textCname}>{username?.split(" ")[0]}</div>
                            <img src={picture || UserFallback} alt="PROFILE" className="w-[29px] rounded-[5px]"/>
                        </div>
                    }
                    </>
                    :
                    <>
                        {
                            type === "non-default" ?
                                <>
                                    <BluePlain
                                        text="S'inscrire"
                                        isButton={false}
                                        className="font-semibold py-[.2em] px-3"
                                        to={'/parcours-entreprise'}
                                    />
                                    <BlueOutline
                                        text="Se connecter"
                                        isButton={false}
                                        className="font-semibold py-[.2em] px-3"
                                        to={'/connexion'}
                                    />
                                </>
                                :
                                <>
                                    <WhitePlain
                                        text="S'inscrire"
                                        isButton={false}
                                        className="font-semibold py-[.2em] px-3"
                                        to={'/inscription'}
                                    />
                                    <WhiteOutline
                                        text="Se connecter"
                                        isButton={false}
                                        className="font-semibold py-[.2em] px-3"
                                        to={'/connexion'}
                                    />
                                </>
                        }
                    </>
            }

        </div>
        
    </>);
};

const MobileMenuMainScreen= ({closer, linkToHomeRef,isWorker, isLoggedIn= false, logout, username, picture, links}: any)=> {
    const [screenActive, setScreenActive]= useState(0);
    const mainScreenRef= useRef<HTMLDivElement>(null);
    const ref1= useRef<HTMLDivElement>(null);
    const ref2= useRef<HTMLDivElement>(null);
    const ref3= useRef<HTMLDivElement>(null);
    const ref4= useRef<HTMLDivElement>(null);

    const goHome= () => {
        if(linkToHomeRef.current){
            linkToHomeRef.current.click();
        }
    };

    const closein3= (event: any)=> {
        event.preventDefault();
        if(mainScreenRef.current){
            mainScreenRef.current.classList.remove('slide-to-the-right');
            mainScreenRef.current.classList.add('slide-to-the-left');
        }
        setTimeout(()=>{
            closer(false);
        }, 350);
    };

    const closeref1= (event: any)=> {
        event.preventDefault();
        if(ref1.current){
            ref1.current.classList.remove('slide-from-the-right');
            ref1.current.classList.add('slide-from-the-left');
        }
        setTimeout(()=>{
            setScreenActive(0);
        }, 350);
    };

    const closeref2= (event: any)=> {
        event.preventDefault();
        if(ref2.current){
            ref2.current.classList.remove('slide-from-the-right');
            ref2.current.classList.add('slide-from-the-left');
        }
        setTimeout(()=>{
            setScreenActive(0);
        }, 350);
    };

    const closeref3= (event: any)=> {
        event.preventDefault();
        if(ref3.current){
            ref3.current.classList.remove('slide-from-the-right');
            ref3.current.classList.add('slide-from-the-left');
        }
        setTimeout(()=>{
            setScreenActive(0);
        }, 350);
    };
    const closeref4= (event: any)=> {
        event.preventDefault();
        if(ref4.current){
            ref4.current.classList.remove('slide-from-the-right');
            ref4.current.classList.add('slide-from-the-left');
        }
        setTimeout(()=>{
            setScreenActive(0);
        }, 350);
    };

    useEffect(()=>{
        if(mainScreenRef.current){
            setTimeout(()=>{
                mainScreenRef.current?.classList.remove('absolute-for-3');
            },350);
        }
        // console.log(username);
    }, [username]);

    const portalPath= window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web": "https://portal.wall-of-share.com/web";

    return(<>
        {
            <div className="block xl:hidden min-h-[100vh] top-0 bottom-0 left-0 right-0 bg-[#f4f4f5] px-[7.7vw] md:px-[10rem] py-[40px] z-[10] slide-to-the-right fixed overflow-y-auto" ref={mainScreenRef}>
                <div className="flex flex-col gap-[51.5px] h-full">
                    <div className="flex flex-row justify-between w-full ">
                        <img src={menuLogo} alt="Logo" onClick={goHome} className="cursor-pointer"/>
                        <img src={closeIcon} alt="Logo" onClick={closein3} className="cursor-pointer"/>
                    </div>
                    <div className="flex sm:flex-row sm:justify-between flex-col gap-[51.5px] grow">
                        <div className="flex flex-col gap-[40px] grow">
                            <div className="flex flex-row justify-between items-center cursor-pointer" onClick={()=>{setScreenActive(1)}}>
                                <div className="text-[22px] leading-[26.4px] font-semibold">Je veux recruter</div>
                                <img src={right} alt="ArrRight" />
                            </div>
                            <div className="flex flex-row justify-between items-center cursor-pointer" onClick={()=>{setScreenActive(2)}}>
                                <div className="text-[22px] leading-[26.4px] font-semibold">Je veux travailler</div>
                                <img src={right} alt="ArrRight" />
                            </div>
                            <div className="flex flex-row justify-between items-center cursor-pointer" onClick={()=>{setScreenActive(3)}}>
                                <div className="text-[22px] leading-[26.4px] font-semibold">Les services</div>
                                <img src={right} alt="ArrRight" />
                            </div>
                            <Link className="flex flex-row justify-between items-center text-[22px] leading-[26.4px] font-semibold cursor-pointer" to={"/a-propos"} >À propos</Link>
                            <Link className="flex flex-row justify-between items-center text-[22px] leading-[26.4px] font-semibold cursor-pointer" to={"/contactez-nous"} >Contactez-nous</Link>
                        </div>
                        <div className="flex flex-col sm:mt-0 mt-auto gap-[20px] grow">
                            {
                                isLoggedIn ?
                                <>
                                    {/* <RoundGreyPlain text="Se déconnecter" isButton={true} className="text-center py-[12px] w-full max-w-[330px] justify-center text-[20px] font-semibold leading-[24px] mx-auto" onClick={logout}/> */}
                                    
                                    <div className="w-full flex flex-row gap-[10px] mt-auto items-center cursor-pointer" onClick={()=>{setScreenActive(4)}}>
                                        <img src={picture || UserFallback} alt="PROFILE-PIC" className="w-[29px] rounded-[5px]"/>
                                        <div className="text-[20px] leading-[100%] font-semibold text-primary-blue">{username?.split(" ")[0]}</div>
                                        <img src={RedArrow} alt="ARR_DOWN" className="transform rotate-[270deg] ml-auto"/>
                                    </div>
                           
                                    
                                </>
                                :
                                <>
                                    <RoundGreyPlain text="S’inscrire" isButton={false} to={"/inscription"} className="text-center py-[12px] w-full max-w-[330px] justify-center text-[20px] font-semibold leading-[24px] mx-auto" />
                                    <RoundGreyOutline text="Se connecter" isButton={false} to={"/connexion"} className="text-center py-[12px] w-full max-w-[330px] justify-center text-[20px] font-semibold leading-[24px] mx-auto" />
                                </>
                            }
                        </div>
                    </div>
                </div>
                {
                    screenActive === 1
                        ?
                        <div className="block xl:hidden fixed h-[100vh] top-0 bottom-0 left-0 right-0 bg-[#f4f4f5] px-[7.7vw] md:px-[10rem] py-[40px] z-[11] slide-from-the-right" ref={ref1}>
                            <div className="flex flex-col gap-[40px] h-full">
                                <div className="flex flex-row justify-between w-full ">
                                    <img src={menuLogo} alt="Logo" />
                                    <img src={closeIcon} alt="Logo" onClick={closein3} />
                                </div>
                                <div className="flex flex-row gap-[2rem]" onClick={closeref1}>
                                    <img src={arrowRight} alt="ArrLeft" className="transform rotate-[180deg]" />
                                    <div className="text-[18px] leading-[21.6px] font-medium">Retour</div>
                                </div>
                                <div className="flex flex-col gap-[2.5rem]">
                                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-[22px] leading-[26.4px] font-semibold">
                                        Je veux recruter
                                    </div>
                                    <div className="flex flex-col gap-[1.3rem] pl-[1.2rem]">
                                        <Link to={"/comment-ca-marche-entreprises"}>
                                            <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                Comment ça marche ?
                                            </div>
                                        </Link>
                                        <Link to={"/plateforme-freelance"}>
                                            <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                Nos freelances
                                            </div>
                                        </Link>
                                        <RoundGreyPlain text="Publier une mission" isButton={false} to={"/parcours-entreprise"} className="px-[20px] py-[10px] text-[18px] leading-[21.6px]" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        screenActive === 2
                            ?
                            <div className="block xl:hidden fixed h-[100vh] top-0 bottom-0 left-0 right-0 bg-[#f4f4f5] px-[7.7vw] md:px-[10rem] py-[40px] z-[11] slide-from-the-right" ref={ref2}>
                                <div className="flex flex-col gap-[40px] h-full">
                                    <div className="flex flex-row justify-between w-full ">
                                        <img src={menuLogo} alt="Logo" />
                                        <img src={closeIcon} alt="Logo" onClick={closein3} />
                                    </div>
                                    <div className="flex flex-row gap-[2rem]" onClick={closeref2}>
                                        <img src={arrowRight} alt="ArrLeft" className="transform rotate-[180deg]" />
                                        <div className="text-[18px] leading-[21.6px] font-medium">Retour</div>
                                    </div>
                                    <div className="flex flex-col gap-[2.5rem]">
                                        <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-[22px] leading-[26.4px] font-semibold">
                                            Je veux travailler
                                        </div>
                                        <div className="flex flex-col gap-[1.3rem] pl-[1.2rem]">
                                            <Link to={"/comment-ca-marche-freelances"}>
                                                <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                    Comment ça marche ?
                                                </div>
                                            </Link>
                                            <Link to={"/prestations-entreprises"}>
                                                <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                    Le services disponibles
                                                </div>
                                            </Link>
                                            <RoundGreyPlain text="Inscription freelance" isButton={false} to={"/parcours-freelance"} className="px-[20px] py-[10px] text-[18px] leading-[21.6px]" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            screenActive === 3
                                ?
                                <div className="block xl:hidden fixed h-[100vh] top-0 bottom-0 left-0 right-0 bg-[#f4f4f5] px-[7.7vw] md:px-[10rem] py-[40px] z-[11] slide-from-the-right" ref={ref3}>
                                    <div className="flex flex-col gap-[40px] h-full">
                                        <div className="flex flex-row justify-between w-full ">
                                            <img src={menuLogo} alt="Logo" />
                                            <img src={closeIcon} alt="Logo" onClick={closein3} />
                                        </div>
                                        <div className="flex flex-row gap-[2rem]" onClick={closeref3}>
                                            <img src={arrowRight} alt="ArrLeft" className="transform rotate-[180deg]" />
                                            <div className="text-[18px] leading-[21.6px] font-medium">Retour</div>
                                        </div>
                                        <div className="flex flex-col gap-[2.5rem] h-full">
                                            <Link to="/prestations-entreprises" className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-[22px] leading-[26.4px] font-semibold">
                                                Les services
                                            </Link>
                                            <div className="flex flex-col pl-[1.2rem] h-full justify-between gap-[20px] pb-[3rem]">
                                                {
                                                    links.map((element: any)=> (
                                                        <MobileMenuLink name={element.name} path={element.path} id={element.id} />
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                screenActive === 4
                                &&
                                <div className="block xl:hidden fixed h-[100vh] top-0 bottom-0 left-0 right-0 bg-[#f4f4f5] px-[7.7vw] md:px-[10rem] py-[40px] z-[11] slide-from-the-right" ref={ref4}>
                                    <div className="flex flex-col gap-[40px] h-full">
                                        <div className="flex flex-row justify-between w-full ">
                                            <img src={menuLogo} alt="Logo" />
                                            <img src={closeIcon} alt="Logo" onClick={closein3} />
                                        </div>
                                        <div className="flex flex-row gap-[2rem]" onClick={closeref4}>
                                            <img src={arrowRight} alt="ArrLeft" className="transform rotate-[180deg]" />
                                            <div className="text-[18px] leading-[21.6px] font-medium">Retour</div>
                                        </div>
                                        <div className="flex flex-col gap-[2.5rem] h-full">
                                            <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-[22px] leading-[26.4px] font-semibold flex flex-row gap-[10px]">
                                                <img src={picture || UserFallback} alt="PROFILE-PIC" className="w-[29px] rounded-[5px]" />
                                                <div className="">
                                                    {username?.split(" ")[0]}
                                                </div>
                                            </div>
                                            <div className="flex flex-col pl-[1.2rem] h-full gap-[20px]">
                                                {isWorker!== null && isWorker? (
                                                    <Link to={"/profil"}>
                                                        <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                            Mon profil
                                                        </div>
                                                    </Link>
                                                ):null}
                                                
                                                <Link to={window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web" : "https://portal.wall-of-share.com/web"}>
                                                    <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                        Mon portail
                                                    </div>
                                                </Link>
                                                <Link to={"/contactez-nous"}>
                                                    <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                        Contacter le support
                                                    </div>
                                                </Link>
                                                <div onClick={logout}>
                                                    <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                                        Se déconnecter
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                }
            </div>
        }
        
        
    </>);
};

const MobileMenuLink= ({path, name, id}: {path: string, name: string, id: any}) => {
    return <Link to={`${path}?id=${id}`}>
        <div className="text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
            {name}
        </div>
    </Link>;
};


export default function Header({type='non-default'}){
    const [submenuAppearing, setSubMenuAppearing]= useState(0);//<- 0: nothing appears; 1: recruter; 2: travailler; 3: services; 4: user menu
    const timerRef= useRef<NodeJS.Timeout|null>(null);
    const invisibleLink= useRef<HTMLAnchorElement>(null);

    const goHome= (e: any)=> {
        //click on the invisible link*
        if(invisibleLink.current){
            invisibleLink.current?.click();
        }
    };

    const showSubMenu= (index: number)=> {
        if(timerRef.current){
            clearTimeout(timerRef.current);
        }
        setSubMenuAppearing(index);
    };

    const hideSubMenu= (index: number)=> {
        timerRef.current= setTimeout(()=> {
            setSubMenuAppearing(0);
        }, 500);
    };

    const [isMobileMenuShown, setIsMobileMenuShown]= useState(false);

    const location= useLocation();

    const [_, setUser]= useState(null);

    const [isWorker, setIsWorker] = useState(null)

    const [loggedIn, setLoggedIn]= useState<boolean>(!!localStorage.getItem("user"));

    const [name, setName]= useState("");

    const [profilePic, setProfilePic]= useState("");

    const withCredentials= !(process.env.REACT_APP_WITH_CREDENTIALS=== 'false');

    const history= useNavigate();

    const checkSession = async () => {

        const response= await post('web/session/get_session_info', {}, {withCredentials: withCredentials});
    
        const data: any = response.data;

        // console.log(data);
        // console.log(data.result);


        const domain= window.location.hostname.includes('.fr') ? "portal.wall-of-share.fr": "portal.wall-of-share.com";

        if (data.error) {
            
            // console.log("No active session");

            await post("web/session/destroy", {}, { withCredentials: withCredentials });

            localStorage.removeItem("user");
            localStorage.removeItem("user_uid");

            

            Cookies.remove('session_id', {path: '/', domain: domain});

            setLoggedIn(false);
            history("/");

            return null;
        } else {
            setIsWorker(data.result?.is_worker)
            if (data.result.uid) {
                setName(data.result.name);
                setProfilePic(data.result.profil_image);
                // console.log("User is logged in:", data.result);
                localStorage.setItem("user_uid", data.result.uid);
                return data.result;
            } else {

                await post("web/session/destroy", {}, { withCredentials: withCredentials });

                localStorage.removeItem("user");
                localStorage.removeItem("user_uid");

                Cookies.remove('session_id', {path: '/', domain: domain});

                setLoggedIn(false);
                
                history("/");
            }
        }
    };

    useEffect(()=>{
        setIsMobileMenuShown(false);
        setSubMenuAppearing(0);

        const userData= localStorage.getItem("user");

        if (userData) {
            setLoggedIn(true);
            setUser(JSON.parse(userData));
            
            checkSession();
            
        } else {
            setLoggedIn(false);
            setUser(null);
        }
        // console.log(user);
        
    }, [location]);


    const [items, setItems] = useState([]);
    const typeFreelance = async ()=>{
        try {
            let res = await _getTypeFreelance();

            let item = res.map((el: any)=>({
                name: el.name,
                path: el.path,
                id: el.id
            }));

            setItems(item);
        } catch (error) {
            console.log({error});
        }
    };
    
    useEffect(()=>{

        typeFreelance();

    },[]);


    const logout= async () => {
        const withCredentials= !(process.env.REACT_APP_WITH_CREDENTIALS=== 'false');
        
        const domain= window.location.hostname.includes('.fr') ? "portal.wall-of-share.fr": "portal.wall-of-share.com";

        await post("web/session/destroy", {}, {withCredentials: withCredentials});

        localStorage.removeItem("user");
        localStorage.removeItem("user_uid");

        Cookies.remove('session_id', {path: '/', domain: domain});

        setLoggedIn(false);
        
        history('/');
    };

    return (
    <>
        {
            isMobileMenuShown
            &&
            <MobileMenuMainScreen closer={setIsMobileMenuShown} linkToHomeRef={invisibleLink} isWorker={isWorker} isLoggedIn={loggedIn} logout={logout} username={name} picture={profilePic} links={items}/>
        }
        <div className={type === 'non-default' ? "bg-primary-blue" : ""}>
            <div className={`max-w-[1900px] mx-auto px-8 py-6 flex justify-between items-center ${type === 'non-default' ? 'bg-primary-blue':''}`} >
                <div className="flex gap-[1rem]">
                    <img src={type === 'non-default' ? LogoTransparent :Logo} alt='Logo' className="h-auto w-[140px]" onClick={goHome} id="wos-logo"/>
                    <Link to={"/"} className="hidden" ref={invisibleLink}></Link>
                    {
                        type === 'non-default'?
                        (
                            <div className={`sm:block px-6 rounded-full border border-white py-2  text-white text-sm cursor-pointer`}>
                                Entreprise
                            </div>
                        ):null
                    }
                </div>
                
                <div className='items-center xl:flex hidden gap-[30px]'>
                    <ul className={`${type === 'non-default'?'text-white':'text-primary-blue'} flex gap-[30px] font-semibold leading-[19.2px] `}>
                        <div
                            className={submenuAppearing=== 1 ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 cursor-default": " cursor-default"}
                            onMouseEnter={()=>{showSubMenu(1)}}
                            onMouseLeave={()=>hideSubMenu(1)}>Je veux recruter</div>

                        <div
                            className={submenuAppearing=== 2 ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 cursor-default": " cursor-default"}
                            onMouseEnter={()=>{showSubMenu(2)}}
                            onMouseLeave={()=>hideSubMenu(2)}>Je veux travailler</div>

                        <div
                            className={submenuAppearing=== 3 ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 cursor-default": " cursor-default"}
                            onMouseEnter={()=>{showSubMenu(3)}}
                            onMouseLeave={()=>hideSubMenu(3)}>Les Services</div>

                        <Link
                            to={'/a-propos'}
                            className="hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500"
                            onMouseEnter={()=>{setSubMenuAppearing(0)}}><span className='uppercase'>&agrave;</span> propos</Link>

                        <Link
                            to={'/contactez-nous'}
                            className="hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500"
                            onMouseEnter={()=>{setSubMenuAppearing(0)}}>Contactez-nous</Link>
                    </ul>
                    <ActionButtons type={type} isLoggedIn={loggedIn} logout={logout} showMenu={()=>{showSubMenu(4)}} username={name} picture={profilePic}/>
                    
                </div>
                <div className="items-center xl:hidden flex" onClick={()=>{setIsMobileMenuShown(true)}}>
                    <img src={type==="non-default" ? hamburgerW : hamburger} alt="Menu" className= "cursor-pointer"/>
                </div>
                
            </div>
            {
                submenuAppearing=== 1 && 
                <div className="w-full absolute h-[320px] bg-[#f4f4f5] top-[78.38px] z-[10] rounded-b-[20px] overflow-hidden shadow-lg" onMouseEnter={()=>{showSubMenu(1)}} onMouseLeave={()=>hideSubMenu(1)}>
                    <SubMenu1 />
                </div>
            }
            {
                submenuAppearing=== 2 &&
                <div className="w-full absolute h-[320px] bg-[#f4f4f5] top-[78.38px] z-[10] rounded-b-[20px] overflow-hidden shadow-lg" onMouseEnter={()=>{showSubMenu(2)}} onMouseLeave={()=>hideSubMenu(2)}>
                    <SubMenu2 />
                </div>
            }
            {
                submenuAppearing=== 3 &&
                <div className="w-full absolute h-[567px] bg-[#f4f4f5] top-[78.38px] z-[10] rounded-b-[40px] overflow-hidden shadow-lg" onMouseEnter={()=>{showSubMenu(3)}} onMouseLeave={()=>hideSubMenu(3)}>
                    <SubMenu3 items={items}/>
                </div>
            }
            {
                submenuAppearing=== 4 &&
                <div className="w-[auto] absolute h-[220px] bg-[#f4f4f5] top-[78.38px] right-0 z-[10] rounded-bl-[20px] overflow-hidden shadow-lg" onMouseEnter={()=>{showSubMenu(4)}} onMouseLeave={()=>hideSubMenu(4)}>
                    <SubMenu4 isWorker={isWorker} logout={logout}/>
                </div>
            }
        </div>
    </>
    )
}

const SubMenu1=() =>{
    return (<>
        <div className="grid grid-cols-[6fr_4fr] h-full">
            <div className="py-[80px] px-[9.7vw]">
                <div className="flex flex-row items-start gap-[6.67vw] h-full">
                    <div className="flex flex-col justify-between h-full">
                        <div className="flex flex-col gap-[.3rem]">
                            <Link to={"/comment-ca-marche-entreprises"}>
                                <div className="group text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                    <div className="relative p-0 m-0">
                                        <img src={copyContentHover} alt="Icon" />
                                        <img src={copyContent} alt="IconHover" className="group-hover:!opacity-0 opacity-100 absolute top-0 left-0 z-[8]"/>
                                    </div>
                                    Comment ça marche ?
                                </div>
                            </Link>
                            <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Découvrez les étapes simples pour recruter les meilleurs freelances.</p>
                        </div>
                        <div className="flex flex-col gap-[.3rem]">
                            <Link to={"/plateforme-freelance"}>
                                <div className="group text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                    <div className="relative p-0 m-0">
                                        <img src={groupHover} alt="Icon" />
                                        <img src={group} alt="IconHover" className="group-hover:!opacity-0 opacity-100 absolute top-0 left-0 z-[8]"/>
                                    </div>
                                    Nos freelances
                                </div>
                            </Link>
                            <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Explorez notre réseau d'experts qualifiés prêts pour vos projets.</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3">
                        <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Publiez votre projet en quelques clics et trouvez le talent idéal.</p>
                        <RoundGreyPlain className="px-[1.6em] py-[.7em]" text="Publier une mission" isButton={false} to={"/parcours-entreprise"} />
                    </div>
                </div>
            </div>
            <div className="bg-center bg-cover" style={{ backgroundImage: `url('/menu/menu-recruter.webp')` }}>
            </div>
        </div>
    </>);
};

const SubMenu2=() =>{
    return (<>
        <div className="grid grid-cols-[6fr_4fr] h-full">
            <div className="py-[80px] px-[9.7vw]">
                <div className="flex flex-row items-start gap-[4.44vw] h-full">
                    <div className="flex flex-col justify-between h-full">
                        <div className="flex flex-col gap-[.3rem]">
                            <Link to={"/comment-ca-marche-freelances"}>
                                <div className="group text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                    <div className="relative p-0 m-0">
                                        <img src={copyContentHover} alt="Icon" />
                                        <img src={copyContent} alt="IconHover" className="group-hover:!opacity-0 opacity-100 absolute top-0 left-0 z-[8]"/>
                                    </div>
                                    Comment ça marche ?
                                </div>
                            </Link>
                            <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Découvrez comment rejoindre la plateforme et trouver des missions.</p>
                        </div>
                        <div className="flex flex-col gap-[.3rem]">
                            <Link to={"/prestations-entreprises"}>
                                <div className="group text-[18px] leading-[21.6px] font-semibold text-primary-blue flex flex-row gap-[.7em] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">
                                    <div className="relative p-0 m-0">
                                        <img src={foldHover} alt="Icon" />
                                        <img src={fold} alt="IconHover" className="group-hover:!opacity-0 opacity-100 absolute top-0 left-0 z-[8]"/>
                                    </div>
                                    Les services disponibles
                                </div>
                            </Link>
                            <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Explorez les services adaptés à vos compétences et expertises.</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3">
                        <p className="text-[14px] leading-[18.23px] text-[#6f6f6f]">Inscivez-vous et accédez à des missions qualifiées.</p>
                        <RoundGreyPlain className="px-[1.6em] py-[.7em]" text="Inscription freelance" isButton={false} to={"/parcours-freelance"} />
                    </div>
                </div>
            </div>
            <div className="bg-center bg-cover" style={{ backgroundImage: `url('/menu/menu-travailler.webp')` }}>
            </div>
        </div>
    </>);
};

const SubMenu3=({items}:any) =>{
    
    return (<>
        <div className="grid grid-cols-[7fr_3fr] h-full">
            <div className="px-[8.2vw] py-[110px] flex flex-col gap-[2em]">
                <Link to="/prestations-entreprises" className="text-[30px] leading-[36px] font-semibold text-[#6f6f6f] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500">Les services</Link>
                <div className="flex flex-row gap-4 justify-between" style={{ flex: "1" }}>
                    <div className="flex flex-col justify-between gap-2 text-[18px] font-semibold leading-[21.6px] text-primary-blue moving-menu">
                        {
                            items.slice(0,7).map((el:any)=>{
                                return (
                                    <Link to={`${el.path}?id=${el.id}`} >{el.name} <img src={arrowRight} alt="arrow" /></Link>
                                )
                            })
                        }
                    </div>
                    <div className="flex flex-col justify-between gap-2 text-[18px] font-semibold leading-[21.6px] text-primary-blue moving-menu">
                        {
                            items.slice(7).map((el:any)=>{
                                return (
                                    <Link to={`${el.path}?id=${el.id}`}>{el.name} <img src={arrowRight} alt="arrow" /></Link>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="bg-primary-blue h-full w-full flex flex-col px-[5vw] py-[110px] justify-between">
                <div className="text-[20px] leading-[24px] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">Rejoignez Wall of Share</div>
                <div className="text-[30px] leading-[36px] font-semibold text-white">Accédez à des opportunités uniques</div>
                <p className="text-[16px] leading-[20.83px] text-[#bbbbc4]">Que vous soyez une entreprise en quête de talents ou un freelance à la recherche de projets, inscrivez-vous pour accéder à des oppertunités sur mesure et collaborer efficacement.</p>
                <RoundBluePlain text="Inscrivez-vous" isButton={false} to={"/inscription"} className="px-[1.6em] py-[.7em]" />
            </div>
        </div>
    </>);
};

const SubMenu4= ({logout, isWorker}: {logout: ()=>void, isWorker: boolean | null}) => {
    const portalPath= window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web": "https://portal.wall-of-share.com/web";
    return <>
        <div className="flex flex-col gap-[25px] px-[37px] items-start justify-center h-full">
            {isWorker !== null  && isWorker ? (
                <LinkAndIcon icon={UserIcon} hoverIcon={UserIconHover} linkText="Mon profil" linkPath="/profil" />
            ):null}
            <LinkAndIcon icon={Portal} hoverIcon={PortalHover} linkText="Mon portail" linkPath={window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web" : "https://portal.wall-of-share.com/web"} />
            <LinkAndIcon icon={MessageIcon} hoverIcon={MessageIconHover} linkText="Contacter le support" linkPath="/contactez-nous" />
            <LinkAndIcon icon={LogoutIcon} hoverIcon={LogoutIconHover} linkText="Se déconnecter" action={logout} />
        </div>
    </>;
};

const LinkAndIcon= ({linkText, icon, hoverIcon, linkPath="", action= ()=> {}}: {linkText: string, icon: any, hoverIcon: any, linkPath?: string, action?: ()=>void}) => {
    useEffect(()=> {
        console.log(linkPath);
    }, []);
    return<>
        <Link to={linkPath} className="group flex flex-row items-center gap-[10px] text-primary-blue hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-orange-500" onClick={action}>
            <div className="relative p-0 m-0">
                <img src={hoverIcon} alt="Icon" className="w-[22px] group-hover:!opacity-100 opacity-0"/>
                <img src={icon} alt={linkText} className="w-[22px] group-hover:!opacity-0 opacity-100 absolute top-0 left-0 z-[8]" />
            </div>
            <div className="text-[16px] leading-[100%] font-normal">{linkText}</div>
        </Link>
    </>;
};